import { render, staticRenderFns } from "./SettingsWH.vue?vue&type=template&id=5d759054&"
import script from "./SettingsWH.vue?vue&type=script&lang=js&"
export * from "./SettingsWH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports